import { render } from "./ServiceJobView.vue?vue&type=template&id=1d6f066f&ts=true"
import script from "./ServiceJobView.vue?vue&type=script&lang=ts"
export * from "./ServiceJobView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__